var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"bodyElement"},[_c('RidingMap',{attrs:{"ridingColors":_vm.ridingColors}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bodyElement header"},[_c('h1',{staticClass:"bigTitle"},[_vm._v("Riding Map")])])
}]

export { render, staticRenderFns }